import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Bhavani Maha',
      rating: 5,
      text: 'Mr. Karthik has magic in his hands. The way the art was done and very quick too. Thanks for the beautiful nail art Karthik!',
      service: 'Nail Art',
    },
    {
      name: 'Sujal Thomas',
      rating: 5,
      text: 'Had an amazing haircut at Envoq — the quality of service received here excels well beyond the amount paid. It\'s my go-to salon for a quick cut.',
      service: 'Haircut',
    },
    {
      name: 'Srikanth Sri',
      rating: 5,
      text: 'The wonderful experience I got here. Awesome treatment, awesome team, and awesome atmosphere. I am really glad with all the treatments provided.',
      service: 'Full Treatment',
    },
    {
      name: 'Happy Customer',
      rating: 5,
      text: 'Great ambiance, skilled staff, and very hygienic. Will definitely come back again!',
      service: 'General Visit',
    },
  ];

  return (
    <section id="testimonials" className="py-16 md:py-24 bg-gradient-to-br from-[#f7f5f2] to-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what our 1,200+ satisfied customers have to say about their Envoq experience.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Card
              key={index}
              className="border-none shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-white"
            >
              <CardContent className="p-6">
                {/* Quote Icon */}
                <Quote className="w-10 h-10 text-accent-primary/20 mb-4" />
                
                {/* Rating */}
                <div className="flex items-center space-x-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-5 h-5 text-yellow-400 fill-yellow-400"
                    />
                  ))}
                </div>

                {/* Review Text */}
                <p className="text-gray-700 text-base leading-relaxed mb-4">
                  "{testimonial.text}"
                </p>

                {/* Author Info */}
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div>
                    <p className="font-semibold text-gray-900">{testimonial.name}</p>
                    <p className="text-sm text-gray-500">{testimonial.service}</p>
                  </div>
                  <div className="w-10 h-10 rounded-full bg-accent-primary flex items-center justify-center">
                    <span className="text-white font-bold text-sm">
                      {testimonial.name.charAt(0)}
                    </span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Google Reviews CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-700 mb-4">
            Read all <span className="font-bold text-accent-primary">1,218 reviews</span> on Google
          </p>
          <a
            href="https://maps.google.com/?cid=1419869882600592434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 bg-white hover:bg-gray-50 text-gray-900 font-semibold px-6 py-3 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 border border-gray-200"
          >
            <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
            <span>View on Google</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;